import { ApiSubUrls, Apis } from 'enums/api-constants'
import { fetchGeneralData } from 'queries/fetchData'

export const fetchSecureRGD = fetchGeneralData<any>(
    `${ApiSubUrls[Apis.AGGREGATIONS]}/greenfield/cards/`,
)
